import { DateTimeService } from '@mews/framework';
import { dispatchWithEventTracking } from '../../../middleware/createAnalyticsMiddleware';
import {
    BODY_CELL_EVENT_CATEGORY,
    DETAIL_FORM_EVENT_CATEGORY,
    FILTER_EVENT_CATEGORY,
    SIDEBAR_EVENT_CATEGORY,
} from '../constants';

export const dispatchWithSidebarClosedTracking = dispatchWithEventTracking({
    eventCategory: SIDEBAR_EVENT_CATEGORY,
    eventAction: 'closed',
});
export const dispatchWithDetailOpenedTracking = dispatchWithEventTracking({
    eventCategory: DETAIL_FORM_EVENT_CATEGORY,
    eventAction: 'opened',
});

export const dispatchWithFilterAppliedTracking = ({ dateRange }: $TSFixMe) =>
    dispatchWithEventTracking({
        eventCategory: FILTER_EVENT_CATEGORY,
        eventAction: 'apply filter',
        eventLabel: `date range difference: ${DateTimeService.diffDays(
            dateRange.endDateTime,
            dateRange.startDateTime
        )}`,
    });

export const dispatchWithCellSelectedTracking = ({ rowIndex, columnIndex }: $TSFixMe) =>
    dispatchWithEventTracking({
        eventCategory: BODY_CELL_EVENT_CATEGORY,
        eventAction: 'select',
        eventLabel: `row ${rowIndex} column ${columnIndex}`,
    });
